import React, { useEffect, useState } from "react";
// import * as loadingAction from "../../../store/loading/action";
// import * as messageAction from "../../../store/message/action";
// import {
//     GET_ALARM_DATA,
//     SAVE_ALARM_DATA,
//     SAVE_LIST_ALARM_DATA,
// } from "../../../helpers/url_api_constant";

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Badge,
    Table,
    CardTitle,
} from "reactstrap";

import PropTypes from "prop-types";
import moment from "moment";
// import PieChart from "../../SummaryReport/SectionAlarm/PieChart";
// import OverButton from "../../../components/Custom/Overbutton";
// import MessageDialog, {
//     useModalShowMessage,
// } from "../../../components/Custom/MessageDialog";
// import ConfirmDialog, {
//     useConfirmDialog,
// } from "../../../components/Custom/ConfirmDialog";
import { useDispatch } from "react-redux";
import BarChartExit from "../SectionDemandSupply/BarChartExit";
import BarChartEntry from "../SectionDemandSupply/BarChartEntry";
// import { post, postUpload } from "../../../helpers/api_helper";

function SectionShipper(props) {
    console.log(props);
    const dispatch = useDispatch();
    // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
    //     "YYYY-MM-DD"));
    const searchDate = { SELECT_DATE: props.date };

    const [listAlarmMedium, setListAlarmMedium] = useState([]);
    const [listAlarmUrgent, setListAlarmUrgent] = useState([]);
    const [totalMedium, setTotalMedium] = useState(null);
    const [totalUrgent, setTotalUrgent] = useState(null);


    useEffect(function () {
        // fetchData();
    }, []);

    const fetchData = async () => {

    };

    useEffect(function () {
        console.log(totalMedium);
        console.log(totalUrgent);
    }, [totalMedium, totalUrgent]);

    function RenderListAlarmMedium(prop) {
        // console.log(prop);
        return (
            <tr>
                <td className="text-center">{prop.indexlist}</td>
                <td className="text-center">{prop.data.TAG_NAME}</td>
                <td className="text-center">{prop.data.TAG_DESC}</td>
                <td className="text-center">{prop.data.TOTAL}</td>
                <td className="text-center">{prop.data.REGION_CODE}</td>
                <td className="text-center">{prop.data.STATE}</td>
                <td className="text-center">{prop.data.RTU_CODE}</td>
                <td className="text-center">{prop.data.DASHBOARD_DESC}</td>
            </tr>
        );
    }



    return (
        <Row>
            <Col sm="12">
                <Card style={{ backgroundColor: "#1E2446", borderRadius: "30px" }}>
                    {/* style={{ backgroundColor: "#001fff1f" }} */}
                    {/* 252D55 */}
                    <CardBody>
                        <Row>
                            <Col sm="12">
                                <Row className="mt-3">
                                    <Col sm="12">
                                        <h5 className="mb-0 sm-0 font-size-22" style={{ color: "#FFFFFF" }}> Summary Shipper  </h5>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <hr />
                                    {/* style={{ color: "#3F91FF" }}  */}
                                </Row>

                                <Row className="mt-2">
                                    <Col sm="6" className="mt-2">
                                        {/* <h4 style={{fontSize:"20px"}}> Demand - Supply</h4> */}
                                        <Row>
                                            <div className="table-responsive" style={{ height: "100%" }}>
                                                {/* hover-table-highlight */}
                                                <Table className="table table-bordered mb-0" style={{ height: "100%" }}>
                                                    <thead>
                                                    </thead>
                                                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                        <tr>
                                                            <td rowSpan={9} style={{ backgroundColor: "#66bae59e", width: "25%" }}> PTT Shipper</td>
                                                        </tr>
                                                        <tr>
                                                            <td rowSpan={4} style={{ width: "20%" }}>Onshore</td>
                                                            <td>Entry Gas</td>
                                                            <td>24872 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>East Gas</td>
                                                            <td>2511 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Balancing</td>
                                                            <td>-1.18 </td>
                                                            <td>%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Overuse</td>
                                                            <td>N/A</td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td rowSpan={4} style={{ width: "20%" }}>Offshore</td>
                                                            <td>Entry Gas</td>
                                                            <td>2828 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>East Gas</td>
                                                            <td>2718 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Balancing</td>
                                                            <td>3.9 </td>
                                                            <td>%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Overuse</td>
                                                            <td>32.8 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Row>
                                    </Col>

                                    <Col sm="6" className="mt-2" style={{ borderLeft: "2px solid #4A5576" }}>
                                        <Row>
                                            <div className="table-responsive" style={{ height: "100%" }}>
                                                {/* hover-table-highlight */}
                                                <Table className="table table-bordered mb-0" style={{ height: "100%" }}>
                                                    <thead>
                                                    </thead>
                                                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                                                        <tr>
                                                            <td rowSpan={9} style={{ backgroundColor: "#f9f29394", width: "25%" }}> EGAT Shipper</td>
                                                        </tr>
                                                        <tr>
                                                            <td rowSpan={4} style={{ width: "20%" }}>Onshore</td>
                                                            <td>Entry Gas</td>
                                                            <td>N/A </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>East Gas</td>
                                                            <td>N/A </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Balancing</td>
                                                            <td>N/A </td>
                                                            <td>%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Overuse</td>
                                                            <td>N/A</td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td rowSpan={4} style={{ width: "20%" }}>Offshore</td>
                                                            <td>Entry Gas</td>
                                                            <td>0 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>East Gas</td>
                                                            <td>0 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Balancing</td>
                                                            <td>0 </td>
                                                            <td>%</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Overuse</td>
                                                            <td>0 </td>
                                                            <td>BBTU</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>


                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

SectionShipper.propTypes = {
    t: PropTypes.any,
    date: PropTypes.any,
}

export default SectionShipper
